import React from "react";
import { Snackbar, Alert, Typography } from "@mui/material";

/**
 * TASK-341 — User-facing 5xx acknowledgment toast.
 */
export default function ErrorNotice({ open, onClose, referenceId }) {
  return (
    <Snackbar
      open={open}
      autoHideDuration={8000}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert onClose={onClose} severity="error" sx={{ width: "100%", maxWidth: 480 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
          We hit a snag
        </Typography>
        <Typography variant="body2">
          Something didn&apos;t work on our side. This has been reported to our development team.
          Please try again in a few minutes.
        </Typography>
        {referenceId ? (
          <Typography variant="caption" display="block" sx={{ mt: 1 }}>
            Reference #{referenceId}
          </Typography>
        ) : null}
      </Alert>
    </Snackbar>
  );
}
